(function() {
    $(document).ready(function() {
        const containers = document.querySelectorAll('.breadcrumb-container');
        containers.forEach(c => {
            c.scrollLeft = c.scrollWidth;
        });
    });
})();

(function() {
    $(document).ready(function() {
        // Reusable function to push data to data layer
        function pushToDataLayer(id) {
            const container = document.getElementById(id);

            const cartTotal = document.getElementById('cart-total').textContent.replaceAll(' ', '').replaceAll('Kč', '');
            const currency = container.getAttribute('data-currency');

            const cartForm = document.getElementById('AjaxCartForm');
            const cartItems = cartForm.querySelectorAll('[data-cart-item]');
            const itemsToPush = [];

            cartItems.forEach(item => {
                const productId = item.getAttribute('data-product-id');
                const itemId = item.getAttribute('data-id');
                const productTitle = item.getAttribute('data-title');
                const productPrice = item.getAttribute('data-price').replaceAll(' ', '').replaceAll('Kč', '');
                const qty = item.getAttribute('data-qty');

                itemsToPush.push({
                    item_id: itemId,
                    product_id: productId,
                    item_name: productTitle,
                    price: productPrice,
                    quantity: qty
                });
            });

            const d = {
                event: 'begin_checkout',
                ecommerce: {
                    currency: currency,
                    value: cartTotal,
                    items: itemsToPush
                }
            };

            console.log(d);

            window.dataLayer = window.dataLayer || [];
            dataLayer.push(d);
        }

        // Handle Checkout button click
        $(document).on('click', '#CheckOut', function(e) {
            // Skip if already processed
            if ($(this).data('processed')) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();
            pushToDataLayer('AjaxCartForm');

            // Mark as processed and submit form
            $(this).data('processed', true);
            $(this).click();
        });
    });
})();
